function NomoreData({ message, FormData }) {
    const msg = message;
    console.log(FormData?.requestType);
    return (
        <>
            <div className="row mt-4">
                <div className="col-lg-12">
                    <div className="bg-white shadow-md rounded p-3 text-center">
                        <span className="fullpage-error-icon" style={{ backgroundImage: `url('/assets/images/ff_no_flts_sector_revamp.png'})` }}></span>

                        <h3 className="text-5 mb-3">{msg}</h3>
                        <h3 className="text-5 mb-3"><small className="mx-2 ">There were no flights found for this date & route combination</small></h3>
                    </div>
                </div>
            </div>
            {FormData?.requestType === '14' && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-6 rounded-xl shadow-lg w-90 text-center">
                        <h2 className="text-lg font-semibold mb-4">
                            Error
                        </h2>
                        <p className="text-sm text-gray-600 mb-6">
                            No reissue results found for the given booking
                        </p>
                        <div className="flex justify-center gap-3">
                            <a
                                href={'/flight/booking-confirmation/' + FormData?.reissueData?.BookingID}
                                className="px-4 py-2 rounded-lg border border-gray-300"
                            >
                                Go to Detail Page
                            </a>
                            <a
                                href={'/flight/amendment/' + FormData?.reissueData?.BookingID + '?requestTypes=' + FormData?.requestType}
                                type="button"
                                className="px-5 py-2 rounded-lg bg-blue-500 hover:bg-blue-600 text-white font-medium shadow transition"
                            >
                                Continue with Manual Amendment
                            </a>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default NomoreData;